// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"522": "48040ef6fc750c71","757": "4464db2dec862fd6",}[chunkId] + ".js"
}